// extracted by mini-css-extract-plugin
export default {"tabWrap":"Tab_tabWrap__VEkYL","tabWrapInner":"Tab_tabWrapInner__6Iuxh","tab":"Tab_tab__Ykpan","tabActive":"Tab_tabActive__Bjmm9"};